<template>
  <ai-client-reviews
    type="star"
    :rating="rating"
    :reviews="reviews"
    :reviews-count="reviewsCount ?? 0"
    :hotel-id="hotelId"
    :all-reviews-load="allReviewsLoad"
    :aria-label="$t('accessibility.description.hotelClientsReviewsList')"
    @load-more="loadMore" />
</template>

<script setup lang="ts">
import type { ReviewItem } from '~/domains/graphql';

interface HotelClientReviewsProps {
  rating?: number | null;
  reviews?: ReviewItem[];
  reviewsCount?: number | null;
  hotelId: string;
  allReviewsLoad: boolean;
}

interface HotelClientReviewsEmits {
  (event: 'loadMore'): void;
}

defineProps<HotelClientReviewsProps>();
const emit = defineEmits<HotelClientReviewsEmits>();

const loadMore = () => emit('loadMore');
</script>
